import React from "react";

const TaxiFareOne = () => {
  return (
    <section className="taxi-fare-one">
      <div className="container">

        {/* SECTION TITLE */}
        <div className="block-title text-center">
          <div className="dot-line"></div>
          <p>Why Choose Us</p>
          <h2>Welcome to Om Sai Cabs</h2>
        </div>

        <div className="row">

          {/* LEFT BLOCK */}
          <div className="col-lg-6">
            <div className="single-taxi-fare-one thm-base-bg hvr-float-shadow">

              <div className="top-block">

                <div className="icon-block">
                  <i className="conexi-icon-taxi"></i>
                </div>

                <div className="text-block">
                  <h3>Safe & Comfortable Rides</h3>

                  <p>
                    We provide clean, comfortable, and well-maintained vehicles
                    for local and outstation travel.
                  </p>
                </div>

              </div>

              <ul className="features-list">

                <li>
                  <div className="name-line">Professional Drivers</div>
                </li>

                <li>
                  <div className="name-line">24/7 Cab Availability</div>
                </li>

                <li>
                  <div className="name-line">Clean & Sanitized Vehicles</div>
                </li>

              </ul>

              <div className="button-block">
                <a
                  href="/booking"
                  target="_blank"
                  rel="noreferrer"
                  className="fare-btn"
                >
                  Book Your Ride
                </a>
              </div>

            </div>
          </div>

          {/* RIGHT BLOCK */}
          <div className="col-lg-6">
            <div className="single-taxi-fare-one thm-base-bg hvr-float-shadow">

              <div className="top-block">

                <div className="icon-block">
                  <i className="conexi-icon-taxi"></i>
                </div>

                <div className="text-block">
                  <h3>Reliable Travel Partner Premium Tours</h3>

                  <p>
                    Om Sai Cabs offers trusted taxi services for airport
                    transfers, city rides, tours, and long-distance journeys.
                  </p>
                </div>

              </div>

              <ul className="features-list">

                <li>
                  <div className="name-line">Affordable Pricing</div>
                </li>

                <li>
                  <div className="name-line">Local & Outstation Trips</div>
                </li>

                <li>
                  <div className="name-line">Easy WhatsApp Booking</div>
                </li>

              </ul>

              <div className="button-block">
                <a
                  href="/contact-us"
                  target="_blank"
                  rel="noreferrer"
                  className="fare-btn"
                >
                  Contact Now
                </a>
              </div>

            </div>
          </div>

        </div>

        {/* BOTTOM TEXT */}
        {/* <div className="block-text text-center">
          <p>
            Om Sai Cabs is committed to providing safe, fast, and dependable
            taxi services with customer satisfaction as our top priority.
          </p>
        </div> */}

      </div>
    </section>
  );
};

export default TaxiFareOne;